import account from './account';
import currency from './currency';
import activeAccount from './activeAccount';
import accountType from './accountType';
import accountGroup from './accountGroup';
import journalEntry from './journalEntry';
import exchangeRate from './exchangeRate';
import controlAccount from './controlAccount';
import statement from './statement';
import dimension from './dimension';
import dimensionType from './dimensionType';
import journalVoucher from './journalVoucher';
import dpk from './dpk';
import aica from './aica';

export default {
    namespaced: true,
    state: {
        routePrefix: "ledger",
        baseCurrency: {
            id: 1,
            name: "Sudanese Pounds",
            abbreviation: "SDG"
        }
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        account,
        currency,
        activeAccount,
        journalEntry,
        exchangeRate,
        controlAccount,
        statement,
        dimension,
        dimensionType,
        journalVoucher,
        accountType,
        accountGroup,
        dpk,
        aica,
    }
}